<template>
  <div>
    <div
      :class="['couponBox',source===0?'couponBg2w':'couponBg1w']"
      :style="{ backgroundImage: `url(${source===0?couponBg2:couponBg1})` }"
      v-for="(item, ind) in couponList"
      :key="ind"
    >
      <!-- pos -->
      <p
        class="posLT"
        v-if="item.fitUser !== 1"
      >{{ item.fitUser === 2 ? '新用户专享' : item.fitUser === 3 ? '老用户专享' : '' }}</p>
      <div :class="['couponLeft',{couponLeftPlus:source===1}]">
        <p
          :class="['pic',{pop1Color:source===1}]"
          v-if="item.discountType === 1"
        >
          <i>￥</i>
          {{ item.discountAmount }}
        </p>
        <p
          :class="['pic',{pop1Color:source===1}]"
          v-else
        >
          {{ item.discountAmount }}
          <i>折</i>
        </p>
        <p :class="['tip',{pop2Color:source===1}]">满{{ item.usableCondition }}可用</p>
      </div>
      <div class="couponRight">
        <p
          class="ellipsis"
          :class="['couponTitle',{pop3Color:source===1}]"
        >
          <i
            v-if="item.frontEndName.substr(0, 1) == '【'"
            class="title-special-processing"
          />
          {{
          item.frontEndName
          }}
        </p>
        <p :class="['tipR',{pop4Color:source===1}]">{{ showType(item.productionFitType) }}</p>
        <div v-if="source===1">
          <div v-if="item.effectiveTimeType === 2">
            <p :class="['time','pop4Color']">{{ Format2(item.effectiveTimeBegin) }}-{{ Format2(item.effectiveTimeEnd) }}</p>
          </div>
          <div v-else>
            <p :class="['time','pop4Color']">{{ daysLeft(item) === 3 ? item.djs : daysLeft(item) }}</p>
          </div>
        </div>
        <div v-else>
          <div v-if="item.effectiveTimeType === 2">
            <p class='time'>{{ Format2(item.effectiveTimeBegin) }}-{{ Format2(item.effectiveTimeEnd) }}</p>
          </div>
          <div v-else>
            <p class='time'>领取后{{ item.effectiveDays}}天内有效</p>
          </div>
        </div>

      </div>

    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { dateTime, replaceHyphens } from '@/utils/tools';

function InitTime(endtime) {
  let hh = null;
  let mm = null;
  let ss = null;
  const time = parseInt(endtime, 0) - new Date().getTime();
  if (time <= 0) {
    return '到期倒计时：00 : 00 : 00';
  }
  hh = Math.floor((time / 60 / 60) % 24);
  mm = Math.floor((time / 60) % 60);
  ss = Math.floor(time % 60);
  const str = `到期倒计时：${hh.toString().padStart(2, '0')} : ${mm
    .toString()
    .padStart(2, '0')} : ${ss.toString().padStart(2, '0')}`;
  return str;
}
export default {
  props: {
    // 0未使用 1已使用 2已过期
    actind: {
      type: Number,
      default: 0,
    },
    // 0来源详情页 1来源支付成功页
    source: {
      type: Number,
      default: 0,
    },
    wholeGiftlist: {
      type: Array,
      default: () => [],
    },

  },
  components: {},
  data() {
    return {
      list: [],
      times: null, // 定时器
      couponBg1: require('../../../assets/img/payment/coupon01.png'),
      couponBg2: require('../../../assets/img/payment/coupon02.png'),
      couponList: [],
    };
  },

  computed: {
    ...mapState(['userInfo']),
  },
  created() { this.getCouponList(); },
  mounted() {
    this.getCouponList();
  },
  watch: {
    // userInfo: {
    //   deep: true,
    //   handler() {
    //     this.getCouponList();
    //   },
    // },
  },
  methods: {
    async getCouponList() {
      this.couponList = this.wholeGiftlist;
      if (this.source === 1) {
        const nowDate = new Date().getTime();
        this.couponList.map((obj) => {
          const endDate = new Date(replaceHyphens(obj.effectiveTimeEnd)).getTime();
          const daystime = endDate - nowDate;
          const days = Math.floor(daystime / 1000 / 60 / 60 / 24);
          if (days === 0) {
            Object.assign(obj, {
              countType: 3,
            });
            this.$set(obj, 'djs', InitTime(endDate));
          }
        });
        this.SETINTERVAL(this.couponList);
      }
    },

    SETINTERVAL(couponList) {
      this.times = setInterval(() => {
        couponList.forEach((key) => {
          if (key.countType === 3) {
            const endTime = new Date(replaceHyphens(key.effectiveTimeEnd)).getTime();
            const nowtime = new Date().getTime();
            const rightTime = endTime - nowtime;
            if (rightTime > 0) {
              const hh = Math.floor((rightTime / 1000 / 60 / 60) % 24);
              const mm = Math.floor((rightTime / 1000 / 60) % 60);
              const ss = Math.floor((rightTime / 1000) % 60);
              // eslint-disable-next-line no-param-reassign
              key.djs = `到期倒计时：${hh.toString().padStart(2, '0')} : ${mm
                .toString()
                .padStart(2, '0')} : ${ss.toString().padStart(2, '0')}`;
            }
          }
        });
      }, 1000);
    },

    // 日期
    dateFormat(item, days, type) {
      if (type === 1) {
        const dateTimes = dateTime(new Date(replaceHyphens(item.effectiveTimeEnd)).getTime());
        return `${dateTimes.year}年${dateTimes.month}月${dateTimes.day}日到期`;
      }
      if (type === 2) {
        return `还剩下${days.toString().padStart(2, '0')}天到期`;
      }

      return 3;
    },
    // 剩余天数
    daysLeft(item) {
      const nowDate = new Date().getTime();
      const endDate = new Date(replaceHyphens(item.effectiveTimeEnd)).getTime();
      const daystime = endDate - nowDate;

      let type = '';
      if (daystime > 0) {
        const days = Math.floor(daystime / 1000 / 60 / 60 / 24);
        if (days > 7) {
          type = 1;
        } else if (days <= 7 && days > 0) {
          type = 2;
        } else {
          type = 3;
        }
        return this.dateFormat(item, days, type);
      }
      return '';
    },

    Format2(date) {
      const dateTimes = dateTime(new Date(replaceHyphens(date)).getTime());
      return `${dateTimes.year}-${dateTimes.month}-${dateTimes.day} ${dateTimes.h}:${dateTimes.m}`;
    },
    showType(type) {
      let text = '';
      switch (type) {
        case 1:
          text = '所有产品';
          break;
        case 2:
          text = '指定产品可用';
          break;
        case 3:
          text = '指定产品可用';
          break;
        case 4:
          text = '仅限产品套餐可用';
          break;
        default:
          text = '指定产品套餐可用';
          break;
      }
      return text;
    },
  },
};
</script>

<style lang="scss" scoped>
.couponBox {
  position: relative;
  display: flex;
  clear: both;
  margin-bottom: 29px;
  padding: 14px 0;
  box-sizing: border-box;
  background-size: 100% 100%;
}
.couponBg1w {
  width: 600px;
  height: 212px;
}
.couponBg2w {
  width: 670px;
  height: 190px;
}
.posLT {
  position: absolute;
  top: 2px;
  left: 2px;
  padding: 0 3px;
  // width: 105px;
  height: 32px;
  color: #ff6c02;
  font-size: 18px;
  line-height: 32px;
  text-align: center;
  background: #fff0e6;
  border-radius: 5px 0 7px 0;
}
// 左板块
.couponLeft {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 26%;
  // border-right: 2px dashed #eee;
}
.couponLeftPlus {
  width: 29.6% !important;
}
.pic {
  color: #ff6c02;
  font-weight: bold;
  font-size: 43px;
  i {
    font-weight: bold;
    font-size: 25px;
    font-style: normal;
  }
}
.tip {
  margin-top: 4px;
  color: #787878;
  font-size: 22px;
  line-height: 31px;
}
// 右板块
.couponRight {
  box-sizing: border-box;
  width: 70%;
  padding-left: 35px;
  padding-top: 14px;
  .couponTitle {
    color: #333;
    font-size: 29px;
    line-height: 36px;
  }
  .tipR {
    margin-top: 14px;
    color: #787878;
    font-size: 22px;
    line-height: 29px;
  }
  .time {
    margin-top: 14px;
    color: #787878;
    font-size: 22px;
    line-height: 29px;
  }
}
.posImg {
  position: absolute;
  right: 36px;
  bottom: 29px;
  width: 101px;
  height: 80px;
}
// 非未使用样式
.notUnused {
  .pic,
  .couponTitle,
  .tipR,
  .time {
    color: #a5a5a5;
  }
}
.immediateFath {
  display: flex;
  justify-content: center;
}
.immediateUse {
  align-self: center;
  width: 56px;
  height: 138px;
  color: #fff;
  font-weight: 500;
  font-size: 22px;
  line-height: 56px;
  letter-spacing: 2px;
  text-align: center;
  background: #ff6c02;
  border-radius: 14px;
  writing-mode: vertical-lr; /* 从左向右 从右向左是 writing-mode: vertical-rl; */
  writing-mode: tb-lr; /* IE浏览器的从左向右 从右向左是 writing-mode: tb-rl； */
}
.pop1Color {
  color: #ff0022 !important;
}
.pop2Color {
  color: #b77026 !important;
}
.pop3Color {
  color: #af691f !important;
}
.pop4Color {
  color: #c78b53 !important;
}
</style>
